import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { StorageService } from '../storage/storage.service';
import { LANGUAGE_KEY } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private storageService = inject(StorageService);
  private translate = inject(TranslateService);

  setLanguage(lng: string) {
    this.translate.use(lng);
    this.storageService.set(LANGUAGE_KEY, lng);
  }

  async getLanguage(): Promise<any> {
    return (await this.storageService.get(LANGUAGE_KEY)) || 'es';
  }

  async getTranslation(key: string): Promise<string> {
    try {
      return await firstValueFrom(this.translate.get(key))
    } catch (error) {
      console.error('Error fetching translation:', error);
      return 'es';
    };
  }
}
